
define('text!TescoMobile_Checkout/template/summary/clubcard-points.html',[],function () { return '<!-- ko if: isDisplayed() --><div class="summary-clubcard" data-bind="html: $t(\'You\\\'ll collect %1\').replace(\'%1\', \'<strong>\' + getValue() + \'</strong>\' + \' \' + $t(\'Tesco Clubcard points\') )"></div><!-- /ko -->';});

